import React, { useEffect, useRef, useState } from 'react';
import Icon from '../primitives/Icon';
import { useTheme } from '../../context/ThemeContext';
import { Button } from '../../components/ui/button';
import './chat.css';

const TopBar = ({ title, subtitle, onShare, onRename }) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const inputRef = useRef(null);
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  const startEdit = () => {
    if (!onRename) return;
    setDraft(title);
    setEditing(true);
  };

  const save = () => {
    const trimmed = draft.trim();
    if (trimmed && trimmed !== title) onRename(trimmed);
    setEditing(false);
  };

  const cancel = () => setEditing(false);

  useEffect(() => {
    if (editing) inputRef.current?.focus();
  }, [editing]);

  return (
    <div className="q-topbar">
      <div className="q-topbar__titles">
        {editing ? (
          <div className="q-topbar__edit">
            <input
              ref={inputRef}
              className="q-topbar__input"
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') save();
                else if (e.key === 'Escape') cancel();
              }}
            />
            <Button size="sm" onClick={save}>Save</Button>
          </div>
        ) : (
          <div className="q-topbar__name">
            {onRename ? (
              <button
                type="button"
                className="q-topbar__title q-topbar__title--edit"
                onClick={startEdit}
                title="Click to rename"
              >
                {title}
              </button>
            ) : (
              <div className="q-topbar__title">{title}</div>
            )}
            {onRename && (
              <button type="button" className="q-topbar__btn q-topbar__btn--icon q-topbar__rename" onClick={startEdit} title="Rename" aria-label="Rename">
                <Icon name="pencil" size={15} />
              </button>
            )}
          </div>
        )}
        {subtitle && !editing && (
          <div className="q-topbar__sub">{subtitle}</div>
        )}
      </div>
      {onShare && (
        <button type="button" className="q-topbar__btn" onClick={(e) => onShare(e.currentTarget)} title="Share">
          <Icon name="share" size={18} />
          <span>Share</span>
        </button>
      )}
      <button
        type="button"
        className="q-topbar__btn q-topbar__btn--icon"
        onClick={toggleTheme}
        title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        <Icon name={isDark ? 'sun' : 'moon'} size={18} />
      </button>
    </div>
  );
};

export default TopBar;
